import { render, staticRenderFns } from "./OrderSuccess.vue?vue&type=template&id=7fcee1eb&"
import script from "./OrderSuccess.vue?vue&type=script&lang=js&"
export * from "./OrderSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports